<template>
    <article>
        <div style="max-width: 770px;">
            <div class="breadcrumbs p14 mb-5">
                <router-link to="/">Home</router-link> &raquo; <router-link to="/unsubscribe">Unsubscribe</router-link> &raquo; <a href="#">Phone</a>
            </div>
            
            <div class="mb-5">
                <h3 class="mb-3">Phone Unsubscribe</h3>
                <p class="light">Use the form below to unsubscribe from your phone number. If you are trying to unsubscribe from SMS marketing, reply STOP to the messages you would like   to not receive.</p>
                <form @submit.prevent="validateBeforeSubmit">
                    <div class="row mb-5">
                        <div class="col-lg-10 col-xl-8">
                            <CleaveInput
                                label="What's your phone number?"
                                id="phone"
                                name="phone"
                                type="tel"
                                maxlength="12"
                                help="Format: 999-999-9999"
                                :cleaveoptions="masks.phone"
                                v-model="phone"
                                v-validate="{ required: true, validateAreaCode: true, regex: /^[0-9]{3}\-[0-9]{3}\-[0-9]{4}$/ }"
                                :exval="validationAttempt"
                                :error="errors.first('phone')"
                            />
                        </div>
                    </div>
                    <div class="my-5">
                        <div v-if="errorMessage" class="alert alert-danger mb-3">
                            Unfortunately there was an error carrying out your action. Please try again later.
                        </div>
                        <div v-if="successMessage" class="alert alert-success mb-3">
                            You have been successfully unsubscribed.
                        </div>
                        <div class="d-flex align-items-center">
                            <button class="btn btn-cta btn-red uc" id="form-submit">{{sending ? 'Sending...' : 'Unsubscribe'}}</button>
                            <div>
                                <transition name="slide">
                                    <span class="some-errors" v-if="(errors.items.length != 0 && validationAttempt)">You have some errors</span>
                                </transition>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="p14 text-right"><router-link to="/">Return Home</router-link></div>
        </div>
    </article>
</template>

<script>
import axios from 'axios';
import CleaveInput from '@/components/form/CleaveInput.vue';

export default {
    name: "UnsubscribePhone",
    components:{
        CleaveInput,
    },
    data() {
	  return {
            validationAttempt: false,
            sending: false,
            errorMessage: false,
            successMessage: false,

			phone: '',
            masks: {
                phone: { numericOnly: true, delimiter: '-', blocks: [3, 3, 4] }
            }
		}
    },
    methods: {
        validateBeforeSubmit() {
            this.sending = true;
            this.successMessage = false;
            this.errorMessage = false;
            this.validationAttempt = true;
			this.$validator.validate().then((result) => {
        		if (result) {
                    this.unsubscribe();
                    return;
                }
                this.sending = false;
      		});
        },
        async unsubscribe(){

            const endpoint = `${process.env.VUE_APP_LOCAL_API}unsubscribe/phone?value=${this.phone}`;
            
			
			try {
				this.sending = true;
                const response = await axios.get(endpoint);

                if(response.data.success){
                    this.validationAttempt = false;
                    this.sending = false;
                    this.successMessage = true;
                    this.phone = '';
                    this.$nextTick().then(() => {
                        this.$validator.reset();
                        this.errors.clear();
                    });
                } else {
                    this.sending = false;
                    this.errorMessage = true;
                }
			} catch(err) {
				this.sending = false;
				console.log(err);
			}
        },
    },
    
}
</script>

<style>

</style>

